import { UiSchema } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';

const dimensionsGrid: UIGridElement[] = [{ fields: { widthCm: 4, heightCm: 4, depthCm: 4 } }];

const uiGrid: UIGridElement[] = [
  { fields: { name: 6, status: 6 } },
  { fields: { sizeDescription: 6, isConsideredLow: 6 } },
  { title: 'Outer Dimensions', fields: { outerDimensions: 12 } },
  { title: 'Inner Dimensions', fields: { innerDimensions: 12 } }
];

export const deliveryContainerSettingsFormUISchema: UiSchema = {
  'ui:submitButtonOptions': { norender: true },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  isConsideredLow: {
    'ui:widget': 'select'
  },
  outerDimensions: {
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    'ui:grid': dimensionsGrid
  },
  innerDimensions: {
    'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
    'ui:grid': dimensionsGrid
  }
};
